import sizes from "@frog/source/data/sizes.js"

const layersList = [
    "submerged-unit",
    "background-block",

    "unit-zone",

    "range",
    "range2",
    "escapezone",
    "dangerzone",
    "shadow",
    "dropshadow",
    "building-sides",

    "terrain",
    "terrain-block",
    "block",
    "edge-block-north",
    "edge-block-west",

    "action-arrow-invoke-skill",
    "action-arrow",
    "action-end",

    "slim-arrow",
    "cursor",

    ///
    "unit",
    ///

    "particle",
    "healthbar",
    "redhealthbar",
    "elemental-icon",
    "ant-arrow",
    "ant-end",
    "arrow",
    "line-ant-arrow",

    "edge-block-south",
    "edge-block-east",
    "foreground-block",

    "fog",
    "debug",

    "preparing-unit",

    // TODO!! CLEAN THIS UP EVENTUALLY!
]

const layers = {}
const maxlayer = layersList.length
layersList.forEach((key, index) => layers[key] = index)

export default function pixel(layerKey, position, space) {
    position = position || {}
    position.x = position.x || 0
    position.y = position.y || 0
    position.z = position.z || 0
    if(sizes.camera.type == "top-down"
    || space == "screenspace") {
        return {
            "x": position.x * sizes.grid.width,
            "y": position.y * sizes.grid.height,
            // "stack": layers[layerKey],
            "stack": position.stack || ((Math.ceil(position.y) * maxlayer) + (layers[layerKey] || 0)),
            // "stack": position.stack || Math.ceil(position.y) + ((layers[layerKey] || 0) / maxlayer)
        }
    }
    if(sizes.camera.type == "isometric") {
        return {
            "x": (position.x - position.y) * (sizes.grid.width / 2),
            "y": ((position.x + position.y) * (sizes.grid.height / 2)) - (position.z * sizes.grid.depth),
            // "stack": Math.round(position.x) + Math.round(position.y) (((layers[layerKey] || 0) / maxlayer) * 1),
            "stack": (Math.round(position.x) * 10000) + (Math.round(position.y) * 100) + Math.ceil(position.z) + (((layers[layerKey] || 0) / maxlayer) * 1),
            // "stack": Math.ceil(position.x) + Math.ceil(position.y) + ((layers[layerKey] || 0) / maxlayer),
            // "stack": position.x + position.y + position.z + (((layers[layerKey] || 0) / maxlayer)),
            // "stack": position.x + position.y + ((layers[layerKey] || 0) / maxlayer),
        }
        // return {
        //     "x":  ((position.x/2) * GRID_WIDTH) - (position.y * GRID_HEIGHT),
        //     "y": ((((position.x/2) * GRID_WIDTH) + (position.y * GRID_HEIGHT)) / 2) - (((position.z || 0) - 1) * GRID_DEPTH),
        //     "z": ((position.z || 0) * 100) + position.x + position.y + (layers[layer] || 0)
        // }
    }
}
